import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Icon from '../../../components/AppIcon';

const MobileQuickActions = () => {
  const [open, setOpen] = useState(false);
  const navigate = useNavigate();

  const actions = [
    { label: 'New Bid', icon: 'FileText', path: '/bid-management', color: 'bg-amber-500' },
    { label: 'Add Project', icon: 'Briefcase', path: '/project-management', color: 'bg-blue-500' },
    { label: 'Assign Resource', icon: 'Package', path: '/resource-management', color: 'bg-violet-500' },
  ];

  const handleAction = (path) => {
    navigate(path);
    setOpen(false);
  };

  return (
    <div className="fixed bottom-6 right-4 z-50 flex flex-col items-end gap-3">
      {open && (
        <div className="flex flex-col items-end gap-2">
          {actions?.map((action, idx) => (
            <button
              key={idx}
              onClick={() => handleAction(action?.path)}
              className="flex items-center gap-2 bg-card border border-border rounded-full px-4 py-2 shadow-lg"
            >
              <span className="text-sm font-medium text-foreground">{action?.label}</span>
              <div className={`w-8 h-8 rounded-full ${action?.color} flex items-center justify-center`}>
                <Icon name={action?.icon} size={16} color="white" />
              </div>
            </button>
          ))}
        </div>
      )}
      <button
        onClick={() => setOpen(!open)}
        className={`w-14 h-14 rounded-full shadow-xl flex items-center justify-center transition-all duration-200 ${
          open ? 'bg-foreground rotate-45' : 'bg-accent'
        }`}
      >
        <Icon name="Plus" size={24} color="white" />
      </button>
    </div>
  );
};

export default MobileQuickActions;
